import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rootNodeLabel: {
    description: 'Visible label of the root node',
    defaultMessage: 'Select All',
    id: 'qId6SO',
  },
});
